import React, { useState, useEffect } from "react";
import QuizHeader from "../../components/pages/Quizzes/QuizHeader";
import QuizBody from "../../components/pages/Quizzes/QuizBody";
import { all_category_type } from "../../utils/constants";
import { setCategoryListByModule } from "../../store/slices/globalSlice";
import { useDispatch } from "react-redux";

const QuizzesPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCategoryListByModule(all_category_type?.RFQ));
  }, []);

  return (
    <>
      <div className="innerContainer">
        <QuizHeader />
        <QuizBody />
      </div>
    </>
  );
};

export default QuizzesPage;
